// File containing helper functions for different performnance calculation functionalities

export const fetchTKOFSettings = async (ACReg) =>
  await fetch(
    process.env.REACT_APP_SERVER_URL + `/getTKOFSettings?ACReg=${ACReg}`,
    {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
}

  );

export const fetchTKOFPerformance = async (requestString) =>
  await fetch(process.env.REACT_APP_SERVER_URL + `/getTKOFPerformance`, {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify({ requestString }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const fetchLDGSettings = async (ACReg) =>
  await fetch(
    process.env.REACT_APP_SERVER_URL + `/getLDGSettings?ACReg=${ACReg}`,
    {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
}
  );

export const fetchLDGPerformance = async (requestString) =>
  await fetch(process.env.REACT_APP_SERVER_URL + `/getLDGPerformance`, {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify({ requestString }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

// Fetches takeoff settings from webservice given an ACReg and saves it as a state
export function getTKOFSettings(ACReg, setTkofSettings, parseString) {

    const makeRequest = async () => {
    try {
      const res = await fetchTKOFSettings(ACReg);
      const response = await res.json();

      parseString(response, function (err, result) {
        const data =
          result['soap:Envelope']['soap:Body']['0']
            .AC_Perf_Settings_TKOF_RWYINFO_VarResponse['0']
            .AC_Perf_Settings_TKOF_RWYINFO_VarResult['0'];
        if (data !== null && data !== '') {
          setTkofSettings(data);
            } else {
          setTkofSettings('No takeoff settings found for flight');
            }
      });
    } catch (err) {
      setTkofSettings('No settings found for given flight: ' + ACReg);
    }
  };
    makeRequest();
}

// Fetches a takeoff performance calculation result from the webservice 
export function getTKOFCalculation(
  formData,
  flightData,
  empNumber,
  parseString,
  setCalculationResult
) {
  let fc = formData.FC;
  let ba = formData.BA;
  let depth = formData.Depth;

    if (fc === null || fc === undefined ) {
    fc = '';
    }
    if (ba === null || ba === undefined ) {
    ba = '';
    }
    if (depth === null || depth === undefined ) {
    depth = '';
    }

    // &lt; = < // &gt; == >
    const requestString = `
    &lt;ACReg&gt;${flightData.sACReg}&lt;/ACReg&gt;
    &lt;ICAO&gt;${formData.ICAO}&lt;/ICAO&gt;
    &lt;RWY&gt;${formData.RWY}&lt;/RWY&gt;
    &lt;ComFltNo&gt;${flightData.sComFltNo}&lt;/ComFltNo&gt;
    &lt;EmpNo&gt;${empNumber}&lt;/EmpNo&gt;
    &lt;WindDir&gt;${formData.WindDir}&lt;/WindDir&gt;
    &lt;WindSpeed&gt;${formData.WindSpeed}&lt;/WindSpeed&gt;
    &lt;OAT&gt;${formData.OAT}&lt;/OAT&gt;
    &lt;QNH&gt;${formData.QNH}&lt;/QNH&gt;
    &lt;AntiSkid&gt;${formData.AntiSkid}&lt;/AntiSkid&gt;
    &lt;PowerManSys&gt;${formData.PowerManSys}&lt;/PowerManSys&gt;
    &lt;ThrRev&gt;${formData.ThrRev}&lt;/ThrRev&gt;
    &lt;LandGear&gt;${formData.LandGear}&lt;/LandGear&gt;
    &lt;RWYCond&gt;${formData.RWYCond}&lt;/RWYCond&gt;
    &lt;BA&gt;${ba}&lt;/BA&gt;
    &lt;Depth&gt;${depth}&lt;/Depth&gt;
    &lt;FC&gt;${fc}&lt;/FC&gt;
    `;


    const makeRequest = async () => {
        try {
      const res = await fetchTKOFPerformance(requestString);
      const response = await res.json();

      parseString(response, function (err, result) {
        const data =
          result['soap:Envelope']['soap:Body']['0'].Perf_TKOF_ReqResponse['0']
            .Perf_TKOF_ReqResult[0];
        if (data !== null && data !== '') {
          setCalculationResult(data);
                } else {
          setCalculationResult('No performance result could be calculated');
                }
      });
        } catch (err) {
      setCalculationResult(
        'An error occured while fetching performance result'
      );
        }
  };
        makeRequest();
}

// Fetches landing settings from webservice given an ACReg and saves it as a state
export function getLDGSettings(ACReg, setLdgSettings, parseString) {

    const makeRequest = async () => {
    try {
      const res = await fetchLDGSettings(ACReg);
      const response = await res.json();

      parseString(response, function (err, result) {
        const data =
          result['soap:Envelope']['soap:Body']['0']
            .AC_Perf_Settings_LDGResponse['0'].AC_Perf_Settings_LDGResult['0'];
        if (data !== null && data !== '') {
          setLdgSettings(data);
            } else {
          setLdgSettings('No takeoff settings found for flight');
            }
      });
    } catch (err) {
      setLdgSettings('No settings found for given flight: ' + ACReg);
    }
  };
    makeRequest();
}

// Fetches a landing performance calculation result from the webservice 
export function getLDGCalculation(
  formData,
  flightData,
  empNumber,
  parseString,
  setCalculationResult
) {
    let fc = formData.ldgFC; 
    let ba = formData.ldgBA;

    if (fc === null || fc === undefined ) {
    fc = '';
    }
    if (ba === null || ba === undefined ) {
    ba = '';
    }

    const requestString = `
    &lt;ACReg&gt;${flightData.sACReg}&lt;/ACReg&gt;
    &lt;ICAO&gt;${formData.ldgICAO}&lt;/ICAO&gt;
    &lt;RWY&gt;${formData.ldgRWY}&lt;/RWY&gt;
    &lt;ComFltNo&gt;${flightData.sComFltNo}&lt;/ComFltNo&gt;
    &lt;EmpNo&gt;${empNumber}&lt;/EmpNo&gt;
    &lt;WindDir&gt;${formData.ldgWindDir}&lt;/WindDir&gt;
    &lt;WindSpeed&gt;${formData.ldgWindSpeed}&lt;/WindSpeed&gt;
    &lt;OAT&gt;${formData.ldgOAT}&lt;/OAT&gt;
    &lt;QNH&gt;${formData.ldgQNH}&lt;/QNH&gt;
    &lt;Flaps&gt;${formData.ldgFlaps}&lt;/Flaps&gt;
    &lt;AntiSkid&gt;${formData.ldgAntiSkid}&lt;/AntiSkid&gt;
    &lt;PowerManSys&gt;${formData.ldgPowerManSys}&lt;/PowerManSys&gt;
    &lt;ThrRev&gt;${formData.ldgThrRev}&lt;/ThrRev&gt;
    &lt;LandGear&gt;${formData.ldgLandGear}&lt;/LandGear&gt;
    &lt;GrSpoiler&gt;${formData.ldgGrSpoiler}&lt;/GrSpoiler&gt;
    &lt;AppClbGrad&gt;${formData.ldgAppClbGrad}&lt;/AppClbGrad&gt;
    &lt;ThrSpeedInc&gt;${formData.ldgThrSpeedInc}&lt;/ThrSpeedInc&gt;
    &lt;NonNormal&gt;${formData.ldgNonNormal}&lt;/NonNormal&gt;
    &lt;RWYCond&gt;${formData.ldgRWYCond}&lt;/RWYCond&gt;
    &lt;ALM&gt;${formData.ldgLW}&lt;/ALM&gt;
    &lt;BA&gt;${ba}&lt;/BA&gt;
    &lt;FC&gt;${fc}&lt;/FC&gt;
    `;


    const makeRequest = async () => {
        try {
      const res = await fetchLDGPerformance(requestString);
      const response = await res.json();

      parseString(response, function (err, result) {
        const data =
          result['soap:Envelope']['soap:Body']['0'].Perf_LDG_ReqResponse['0']
            .Perf_LDG_ReqResult[0];
        if (data !== null && data !== '') {
          setCalculationResult(data);
                } else {
          setCalculationResult('No performance result could be calculated');
                }
      });
        } catch (err) {
      setCalculationResult(
        'An error occured while fetching performance result'
      );
        }
  };
        makeRequest();
}

// fetches the option list of a given tagname for takeoff settings
export function getOptionList(settings, tagName) {
  let optionList = [];
    if (settings !== null || settings !== undefined) {
        for (let i = 0; i < settings?.SettingList[0]?.ToDcSetting.length; i++) {
            if (settings?.SettingList[0]?.ToDcSetting[i]?.m_sTagName[0] === tagName) {
        optionList.push(
          ...settings?.SettingList[0]?.ToDcSetting[i]?.OptionList[0].ToDcOption
        );
            }
        }
    }
    
  return optionList;
}

// fetches the option list of a given tagname for landing settings 
export function getLDGOptionList(settings, tagName) {
  let optionList = [];
    if (settings !== null || settings !== undefined) {
        for (let i = 0; i < settings?.SettingList[0]?.LDcSetting.length; i++) {
            if (settings?.SettingList[0]?.LDcSetting[i]?.m_sTagName[0] === tagName) {
        optionList.push(
          ...settings?.SettingList[0]?.LDcSetting[i]?.OptionList[0].LDcOption
        );
            }
        }
    }
    
  return optionList;
}

// gets a list of all airport icao from a given setting object 
export function getICAOList(settings) {
  let icaoList = [];
    if (settings === null || settings === undefined) {
    return [];
    }

  if (settings?.ADList?.[0]?.string?.length) {
    for (let i = 0; i < settings.ADList[0].string.length; i++) {
      icaoList.push(settings.ADList[0].string[i]?.substring(0, 4) ?? '');
    }
    }

  return icaoList;
}


// gets the max min and min value of a certain tag name for a ldg setting
export function getLDGMaxMin(settings, tagName) {
  let maxValue = 0;
  let minValue = 0;

    if (settings === null || settings === undefined) {
    return { max: 0, min: 0 };
    }

    for (let i = 0; i < settings?.SettingList[0]?.LDcSetting.length; i++) {
        if (settings?.SettingList[0]?.LDcSetting[i]?.m_sTagName[0] === tagName) {   
      minValue =
        settings?.SettingList[0]?.LDcSetting[i]?.OptionList[0]?.LDcOption[0]
          ?.m_dbValue;
      maxValue =
        settings?.SettingList[0]?.LDcSetting[i]?.OptionList[0]?.LDcOption[1]
          ?.m_dbValue;
        }
    }

  return { max: maxValue, min: minValue };
}

// gets the max min and min value of a certain tag name for a tkof setting
// if depth = true, want to check name instead of tag name
export function getTKOFMaxMin(settings, tagName, depth) {
  let maxValue = 0;
  let minValue = 0;

    if (settings === null || settings === undefined) {
    return { max: 0, min: 0 };
    }

    if (!depth) {
        for (let i = 0; i < settings?.SettingList[0]?.ToDcSetting.length; i++) {
            if (settings?.SettingList[0]?.ToDcSetting[i]?.m_sTagName[0] === tagName) {   
        minValue =
          settings?.SettingList[0]?.ToDcSetting[i]?.OptionList[0]?.ToDcOption[0]
            ?.m_dbValue;
        maxValue =
          settings?.SettingList[0]?.ToDcSetting[i]?.OptionList[0]?.ToDcOption[1]
            ?.m_dbValue;
            }
        }
    } else {
        for (let i = 0; i < settings?.SettingList[0]?.ToDcSetting.length; i++) {
            if (settings?.SettingList[0]?.ToDcSetting[i]?.m_sName[0] === tagName) {   
        minValue =
          settings?.SettingList[0]?.ToDcSetting[i]?.OptionList[0]?.ToDcOption[0]
            ?.m_dbValue;
        maxValue =
          settings?.SettingList[0]?.ToDcSetting[i]?.OptionList[0]?.ToDcOption[1]
            ?.m_dbValue;
            }
        }
    }
    

  return { max: maxValue, min: minValue };
}